// Filters the partners table on the golfer career page by course without a
// page reload. Every course's rows are already in the DOM as their own tbody,
// so switching is a class toggle rather than a request.
//
// Deliberately does NOT touch history.replaceState: passing a bare {} there
// wipes the Turbolinks restorationIdentifier and breaks the back button.

const PartnerCourseFilter = {
  init() {
    const root = document.getElementById('partner-courses');
    if (!root || root.dataset.filterReady === 'true') return;
    root.dataset.filterReady = 'true';

    const select = root.querySelector('[data-partner-filter]');
    const bodies = Array.from(root.querySelectorAll('[data-partner-course]'));
    if (!select || bodies.length === 0) return;

    function apply() {
      bodies.forEach((body) => {
        body.classList.toggle('hidden', body.dataset.partnerCourse !== select.value);
      });
    }

    select.addEventListener('change', apply);
    apply();
  }
};

document.addEventListener('DOMContentLoaded', PartnerCourseFilter.init);
document.addEventListener('turbolinks:load', PartnerCourseFilter.init);

// Turbolinks caches the DOM with data-filter-ready already set, so the flag
// has to be cleared before caching. Otherwise init() short-circuits when the
// snapshot is restored by the back button and the restored nodes, which are
// new elements, never get their listeners.
document.addEventListener('turbolinks:before-cache', () => {
  const root = document.getElementById('partner-courses');
  if (root) delete root.dataset.filterReady;
});

export default PartnerCourseFilter;
